import { render, staticRenderFns } from "./BeneficiaryDonationDetails.vue?vue&type=template&id=f6eac60e"
import script from "./BeneficiaryDonationDetails.vue?vue&type=script&lang=js"
export * from "./BeneficiaryDonationDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports